var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D66FF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.49,19.96c0-0.28-0.1-0.55-0.3-0.75l-2.74-2.82c-0.4-0.42-1.07-0.43-1.48-0.02L16.19,21 c-0.2,0.19-0.31,0.46-0.32,0.74c0,0.28,0.1,0.55,0.3,0.75l2.74,2.82c0.21,0.21,0.48,0.32,0.75,0.32c0.26,0,0.53-0.1,0.73-0.3 l4.78-4.63C25.37,20.5,25.49,20.23,25.49,19.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.68,29.97c-3.87-1.37-6.47-5.04-6.47-9.15c0-4,2.51-7.64,6.24-9.07c0.45-0.17,0.68-0.68,0.51-1.13 C17.81,10.22,17.4,10,17,10.07c-0.02,0-0.03-0.01-0.05-0.01l-4.56-0.41c-0.37-0.03-0.71,0.16-0.87,0.49 c-0.16,0.33-0.1,0.72,0.16,0.98l1.35,1.41c-2.22,2.13-3.56,5.11-3.56,8.28c0,4.85,3.07,9.19,7.64,10.8 c0.1,0.03,0.19,0.05,0.29,0.05c0.36,0,0.7-0.22,0.82-0.58C18.37,30.63,18.13,30.13,17.68,29.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.48,28.97c2.22-2.13,3.56-5.11,3.56-8.28c0-4.85-3.07-9.19-7.64-10.8c-0.1-0.03-0.19-0.05-0.29-0.05 c-0.36,0-0.7,0.22-0.82,0.58c-0.16,0.46,0.08,0.96,0.53,1.12c3.87,1.37,6.47,5.04,6.47,9.15c0,4-2.51,7.64-6.24,9.07 c-0.45,0.17-0.68,0.68-0.51,1.13c0.15,0.4,0.56,0.62,0.96,0.55c0.02,0,0.03,0.01,0.05,0.01l4.56,0.41 c0.37,0.03,0.71-0.16,0.87-0.49c0.16-0.33,0.1-0.72-0.16-0.98L28.48,28.97z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon_4.4e571cf729f7a1a633c802fc830a3bf5.svg";
export { ForwardRef as ReactComponent };